import { gpt } from '../actions/types';

const initialState = {
  loading: false,
  gptData: [],
  error: null
};

const gptReducer = (state = initialState, action) => {
  switch (action.type) {
    case gpt.FETCH_GPT_REQUEST:
      return { ...state, loading: true, error: null };
    case gpt.FETCH_GPT_SUCCESS:
      return {
        ...state,
        loading: false,
        gptData: [...state.gptData, action.payload] // Store the payload directly
      };
    case gpt.FETCH_GPT_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default gptReducer;
